import { Pipe, PipeTransform } from '@angular/core';
import { BrandService } from 'app/services/brand.service';

/**
 * Shows a (translated) text for the current brand (#183):
 *   {{ 'Welcome to IMMOSURANCE!' | translate | brand }}  ->  'Welcome to IMMOKREDITA!'
 * Texts are unchanged on Immosurance.
 */
@Pipe({ name: 'brand', standalone: true })
export class BrandPipe implements PipeTransform {
    constructor(private _brandService: BrandService) {}

    transform(value: string): string {
        return this._brandService.rebrand(value);
    }
}
